// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7.5 2.71741L2 5.92575V21.5001L7.5 19.2328V2.71741Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M9.5 18.9097L11.5 20.0908V16.5C11.5 14.1988 12.6958 12.1769 14.5 11.0218V5.09051L9.5 2.1377V18.9097Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 2.50012V11.3762C20.897 10.5139 19.5085 10 18 10C17.4837 10 16.9815 10.0602 16.5 10.1739V4.76744L22 2.50012Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21.25 15.25V16H22.499V22.5H13.499V16H14.75V15.25C14.75 13.4551 16.2051 12 18 12C19.7949 12 21.25 13.4551 21.25 15.25ZM19.25 15.25C19.25 14.5596 18.6904 14 18 14C17.3096 14 16.75 14.5596 16.75 15.25V16H19.25V15.25Z"}}]};

const MapLockedFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'map-locked-filled',
    ref,
    icon: element,
  },
));

MapLockedFilledIcon.displayName = 'MapLockedFilledIcon';

export default MapLockedFilledIcon;
